export function buildTtsPayload(
  text,
  speakerOne = {},
  speakerTwo = {},
  assignments = [],
) {
  const source = String(text || "");
  const speakerOneVoice = String(speakerOne?.id || "");
  const speakerTwoVoice = String(speakerTwo?.id || "");
  const speakerOneName = String(speakerOne?.name || "Speaker1");
  const speakerTwoName = String(speakerTwo?.name || "Speaker2");
  if (!speakerOneVoice) return { text: source, voice: "" };
  if (!speakerTwoVoice) {
    return {
      text: source
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean)
        .join("\n"),
      voice: speakerOneVoice,
    };
  }
  const markedSections = (Array.isArray(assignments) ? assignments : [])
    .filter(
      (assignment) =>
        assignment?.voice &&
        assignment?.text &&
        [speakerOneVoice, speakerTwoVoice].includes(assignment.voice),
    )
    .sort((left, right) => Number(left.start) - Number(right.start));
  const lines = [];
  let cursor = 0;
  const addLine = (voice, fragment) => {
    const speaker = voice === speakerTwoVoice ? speakerTwoName : speakerOneName;
    String(fragment || "")
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter(Boolean)
      .forEach((textFragment) => lines.push({ speaker, text: textFragment }));
  };
  markedSections.forEach((assignment) => {
    const start = Math.max(0, Math.min(Number(assignment.start) || 0, source.length));
    const end = Math.max(start, Math.min(Number(assignment.end) || 0, source.length));
    if (start < cursor) return;
    addLine(speakerOneVoice, source.slice(cursor, start));
    addLine(assignment.voice, source.slice(start, end).trim());
    cursor = end;
  });
  addLine(speakerOneVoice, source.slice(cursor));

  return {
    text: lines.map((line) => `${line.speaker}: ${line.text}`).join("\n"),
    speakers: [
      { speaker: speakerOneName, id: speakerOneVoice },
      { speaker: speakerTwoName, id: speakerTwoVoice },
    ],
  };
}
